<template>
  <!-- WRAPPER -->
  <div class="wrapper">
    <!-- .blog-posts -->
    <div v-if="!loading" class="blog-posts readable-content">
      <blog-by-description
        v-for="(items, index) in allblogs"
        :key="index.toString()"
        v-bind="items"
      />
      <!-- .post -->

      <!-- post nav -->
      <!-- <nav class="navigation" role="navigation" v-if="navigation">
        <div class="nav-previous">
          <a href="#"> <span class="meta-nav">←</span> Older posts </a>
        </div>
        <div class="nav-next">
          <a href="#">
            Newer posts
            <span class="meta-nav">→</span>
          </a>
        </div>
      </nav> -->
      <!-- post nav -->
      <!-- post pagination -->
      <!-- <nav class="post-pagination" v-if="!navigation">
        <ul class="pagination">
          <li class="pagination-first"><a href="#"> First </a></li>
          <li class="pagination-prev"><a href="#" rel="prev"> « </a></li>
          <li class="pagination-num"><a href="#"> 1 </a></li>
          <li class="pagination-num current"><a href="#"> 2 </a></li>
          <li class="pagination-num"><a href="#"> 3 </a></li>
          <li class="pagination-next"><a href="#" rel="next"> » </a></li>
          <li class="pagination-last"><a href="#"> Last </a></li>
        </ul>
      </nav> -->
      <!-- post pagination -->
    </div>
    <!-- .blog-posts -->
  </div>
  <!-- WRAPPER -->
</template>
<script>
import ALLBLGOWITHDETAIL from "@/json/allBlogWithDetail";

export default {
  name: "AllBlogWithDesctiption",
  data() {
    return {
      loading: false,
      allblogs: ALLBLGOWITHDETAIL
    };
  },
  watch: {
    $route(to, from) {
      if (to.path === from.path) {
        this.fetchBlog();
      }
    }
  },
  beforeMount() {
    this.fetchBlog();
  },
  methods: {
    fetchBlog() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let url = "/blogs";
      const query = this.$route.query.s;
      if (query && query.length > 0) {
        url = `${url}?s=${query}`;
      }
      this.$axios
        .get(url)
        .then(res => {
          this.allblogs = res.data;
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
